//
import { Record } from 'immutable';

import type { DialogProps } from '@mui/material/Dialog';

import type { ReactElement, SyntheticEvent } from 'react';
import { DIALOG_CLOSE_EVENTS } from '../StdDialogDeprecated/types';
export const ACTION_EVENT_TYPES = ['CONFIRM', 'DENY', ...DIALOG_CLOSE_EVENTS];

export type ConfirmationDialogProps = Omit<DialogProps, 'title' | 'open'> & {
  title: string | ReactElement;
  content: any;
  contentViewId?: string | null;

  confirmLabel?: string;
  denyLabel?: string | null;
  hideBackdrop?: boolean;
  allowNesting?: boolean;

  confirmAction: ((reason?: string, closeEvent?: SyntheticEvent) => void) | null;
  denyAction?: ((reason?: string, closeEvent?: SyntheticEvent) => void) | null;
  tertiaryAction?: ((reason?: string, closeEvent?: SyntheticEvent) => void) | null;
  onClose?: (closeEvent?: SyntheticEvent, reason?: string) => void;

  dialogCloseAliasAction?: string;
  size?: string | null;
  confirmStartIcon?: null | ReactElement;

  confirmButtonVariant?: string;
  denyButtonVariant?: string;
  tertiaryLabelVariant?: string;

  tertiaryLabel?: string | null;
  textEntryConfirmationText?: string | null;
  unregisterContentViewOnClose?: boolean;
};
export const mkConfirmationDialogProps = Record<ConfirmationDialogProps>({
  title: '',

  content: '',
  contentViewId: null,
  size: null,

  confirmLabel: 'OK',
  confirmButtonVariant: 'contained',
  confirmStartIcon: null,

  denyLabel: 'Cancel',
  denyButtonVariant: 'outlined',

  confirmAction: null,
  denyAction: null,
  onClose: undefined,
  hideBackdrop: false,
  allowNesting: undefined,

  dialogCloseAliasAction: 'DENY',

  textEntryConfirmationText: null,
  unregisterContentViewOnClose: false,

  tertiaryLabel: null,
  tertiaryAction: null,
  tertiaryLabelVariant: 'delete',
});

export const DIALOG_TYPE = 'DIALOG_CONFIRMATION';
